import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment.prod'

import { Observable, of } from 'rxjs';

// import { Observable } from 'rxjs/dist/types/internal/Observable';
// import { of } from 'rxjs/dist/types/internal/Observable/of';


import { Router } from '@angular/router';



const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    //'Authorization': 'my-auth-token',
    'IP': 'my-ip-address',
    'IMEI': "Web"
  })
};

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private apiurl = environment.apiurl;

  constructor(private http: HttpClient,
    private router: Router) { }

  public login(UserId: string, RowId: string, UserName: string, token: string, isAdUser: boolean) {
    sessionStorage.setItem('ACCESS_TOKEN', token);
    sessionStorage.setItem('UserId', UserId);
    sessionStorage.setItem('RowId', RowId);
    sessionStorage.setItem('UserName', UserName);
    sessionStorage.setItem('isAdUser', String(isAdUser));
  }

  public isLoggedIn() {
    return sessionStorage.getItem('ACCESS_TOKEN') !== null;
  }

  public isAdUser() {
    return sessionStorage.getItem('isAdUser') == String(true);
  }

  public getToken() {
    return sessionStorage.getItem('ACCESS_TOKEN') as string;
  }

  public getUserId() {
    return sessionStorage.getItem('UserId') as string;
  }

  public getRowId() {
    return sessionStorage.getItem('RowId');
  }

  public getUserName() {
    return sessionStorage.getItem('UserName');
  }


  public setPermission(o: string) {
    sessionStorage.setItem('Permission', JSON.stringify(o));
  }

  public getPermission() {
    return JSON.parse(sessionStorage.getItem('Permission') as string);
  }

  public getDomain() {
    return environment.domain;
  }

  public getUserDesc() {
    if (this.getRowId() != null) {
      return this.getDomain() + "/" + this.getUserId();
    }
    return "";
  }

  public logout() {
    sessionStorage.clear();
  }

  public checkPermission(o: string) {
    var data = "|";
    this.getPermission().forEach((x: { PermissionId: string; }) => data = data + x.PermissionId + "|");
    var hasPermission = data.indexOf("|" + o + "|");
    if (hasPermission <= -1) {
      return false
    }
    return true;
  }



  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // console.log(error);
      // TODO: send the error to remote logging infrastructure
      if (error.status == 401) // log to console instead
      {
        window.alert("The Session is Expired");
        window.location.reload();
        this.logout();
      }

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}